/** @jsxImportSource theme-ui */
import { Container, Flex, Heading } from 'theme-ui';
import Section from '@/components/Section';
import RepairCompanies from '@/containers/voss/RepairCompanies';
import DeadLetters from '@/containers/voss/DeadLetters';

const VossToolsPage = () => {
    return (
        <Container>
            <Flex sx={{ flexDirection: 'column', gap: 3 }}>
                <Heading as="h2">Voss tools</Heading>
                <Section>
                    <Heading as="h3">Repair companies</Heading>
                    <RepairCompanies />
                </Section>
                <Section>
                    <Heading as="h3">Dead-letter queues</Heading>
                    <DeadLetters />
                </Section>
            </Flex>
        </Container>
    );
};

export default VossToolsPage;
